import React from "react";
import PropTypes from "prop-types";
//import material-ui components
import withStyles from "@material-ui/core/styles/withStyles"
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
//import material icons
import Close from "@material-ui/icons/Close";
//import core components
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput";


import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

class NewMachineDialog extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            id: "",
            address: "",
            organization_id: null,
        };
    }

    _changeValue(e, type) {
        const value = e.target.value;
        const next_state = {};
        next_state[type] = value;
        this.setState(next_state)
    }

    render(){
        const { classes, onCancel, onSave, isOpened } = this.props;
        return (
            <Dialog
                classes={{
                    root: classes.center,
                    paper: classes.modal
                }}
                open={isOpened}
                onClose={() => onCancel()}
            >
                <DialogTitle
                    disableTypography
                    className={classes.modalHeader}
                >
                    <IconButton
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={() => onCancel()}
                    >
                        <Close className={classes.modalClose} />
                    </IconButton>
                    <h4 className={classes.modalTitle} >Создание нового автомата</h4>
                </DialogTitle>
                <DialogContent className={classes.modalBody}>
                    <CustomInput
                        labelText="ID"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            value: this.state.id,
                            onChange: e => this._changeValue(e, "id")
                        }}
                        helperText="Оставьте пустым для значения по умолчанию"
                    />
                    <CustomInput
                        labelText="Адрес"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            value: this.state.address,
                            onChange: e => this._changeValue(e, "address")
                        }}
                    />
                    <FormControl className={classes.selectWrapper} disabled={!this.props.organizationEditable}>
                        <InputLabel>Организация</InputLabel>
                        <Select
                            value={this.state.organization_id}
                            onChange={(e) => this._changeValue(e, "organization_id")}
                            inputProps={{
                                name: 'organization',
                            }}
                            className={classes.select}
                        >
                            <MenuItem value=""><em>По умолчанию</em></MenuItem>
                            {this.props.organizations.map((org, key) => (
                                <MenuItem value={org.id} key={key}>{org.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions className={classes.modalFooter} >
                    <Button color="primary"
                            onClick={() => onSave(this.state)}
                    >
                        Сохранить
                    </Button>
                    <Button color="primary" simple
                            onClick={() => onCancel()}
                    >
                        Отменить
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

NewMachineDialog.propTypes = {
    isOpened: PropTypes.bool,
    organizations: PropTypes.array,
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
};

export default withStyles(modalStyle)(NewMachineDialog);


// WEBPACK FOOTER //
// ./src/components/Dialogs/NewMachineDialog.jsx